import type { ConfigOverrideKey } from '#dn-types/host.ts';
import type { OverrideMap, OverridePlusSource } from '../../hooks/useOverrideMaps.ts';

/**
 * Sort a map into two halves, with the first half containing an extra item if there's an odd number.
 *
 * The order is determined by a provided {@link keyOrder}
 */
export function makeHalves(map: OverrideMap, keyOrder: ConfigOverrideKey[]) {
  const firstHalf: OverridePlusSource[] = [];
  const secondHalf: OverridePlusSource[] = [];

  // Sort out map into halves, in the right order
  for (const oKey of keyOrder) {
    const config = map.get(oKey);
    if (!config) continue;
    if (firstHalf.length < map.size / 2) {
      firstHalf.push(config);
    } else {
      secondHalf.push(config);
    }
  }

  return { firstHalf, secondHalf };
}
